import React from 'react';
import ReactDOM from 'react-dom';
import App from 'containers/App';
// import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Route } from 'react-router-dom'
import { ThemeProvider, injectGlobal } from 'styled-components'
import GA from 'utils/Analytics'

const theme = {
  primary: '#262626',
  gutter: '.6rem',
  black: '#020101',
  white: '#fafafa',
  borderStyle: '2px solid black',
  pageMargin: '1rem',
  small: '760px',
  headerHeight: '65px'
}

injectGlobal`
  html {
    font-size: 62.5%; // sets 'root' font size to 10px
    box-sizing: border-box;
  }
  // mobile first
  body {
    padding: 0;
    margin: 0;
    font-family: "Arial Narrow", "Arial", sans-serif;
    font-size: 1.2rem; // 14px
    line-height: 1.5;
    letter-spacing: .1em;
  }
  div {
    box-sizing: border-box;
  }
  * {
    box-sizing: border-box;
  }
  a {
    // font-weight: normal !important;
  }
  p, h1, h2, h3, h4, a {
    -webkit-margin-before:0em;
    -webkit-margin-after:0em;
    margin-bottom: .5em;

    // font-weight: bold;
  }
  p {
    font-size: .8rem;
  }

  *::selection {
    background: #356337; /* WebKit/Blink Browsers */
    color: white;
  }
  a::selection {
    background: #bf4b37; /* WebKit/Blink Browsers */
  }
  img::selection {
    background: #7f6c55; /* WebKit/Blink Browsers */
  }

  h1 {font-size: 5.063rem;}
  h2 {font-size: 2.75rem;}
  h3 {font-size: 2.25rem;}
  h4 {font-size: 1.5rem;}

  hr {
    border: none;
    border-bottom: 2px solid black;
  }
  @media (min-width: ${props => props.theme.small}) {
    body {
      font-size: 1.6rem;
    }
    h2 {
      font-size: 3.375rem;
    }
  }
`

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <Route path="/" component={App}></Route>
    </ThemeProvider>
  </BrowserRouter>, document.getElementById('root'));

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js